var azureDB = require("./soar");
var graph = require("@microsoft/microsoft-graph-client");

function getAuthenticatedClient(accessToken) {
  const client = graph.Client.init({
    authProvider: (done) => {
      done(null, accessToken.accessToken);
    },
  });

  return client;
}

//gets name, email and avatar
export async function getUserDetails(accessToken) {
  const client = getAuthenticatedClient(accessToken);

  const user = await client.api("/me").get();
  try {
    const avatar = await client.api("me/photos/48x48/$value").get();
    user["avatar"] = avatar ? avatar : null;
  } catch {
    user["avatar"] = null;
  }
  console.log("UserEmail:", user.mail.split("@")[0]);

  // const sql = `SELECT * FROM SystemUsers WHERE Email = '${user.mail}' FOR XML AUTO`;
  // const azureUser = await azureDB.AzureDB("Query", sql);
  // user["azureInfo"] = azureUser.result.SystemUsers;
  // console.log("AzureUser: ", user["azureInfo"]);
  const safyInfo = JSON.parse(
    await azureDB.reactDBWhoAmI(user.mail.split("@")[0], user.id)
  ).UserInfo.row[0];
  user["safyInfo"] = safyInfo;
  console.log("SAFY INFO:", safyInfo);
  let divisions = [];
  safyInfo.divisions.forEach((element) => {
    if (element.Active === "1") {
      divisions.push(element.DivisionName);
    }
  });
  divisions.sort();
  user["divisions"] = divisions;
  let modules = [];
  safyInfo.modules.forEach((element) => {
    if (element.Active === "1") {
      modules.push(element.ModuleName);
    }
  });
  user["modules"] = modules;
  return user;
}

//gets 10 latest calendar events in descending order
export async function getEvents(accessToken) {
  const client = getAuthenticatedClient(accessToken);

  const events = await client
    .api("/me/events")
    .select("subject,organizer,start,end")
    .orderby("createdDateTime DESC")
    .get();

  return events;
}

export async function searchUsers(accessToken, searchQuery) {
  const client = getAuthenticatedClient(accessToken);

  const users = await client
    .api("users")
    .header("ConsistencyLevel", "eventual")
    .query(
      `$search="displayName:${searchQuery}"&$filter=accountEnabled eq true`
    )
    .get();

  return users;
}
